<template>
  <div class="pause-picker">
    <template v-if="!confirmed">
      <button type="button" class="btn btn-link px-0 mb-3 text-decoration-none" @click="$emit('close')">
        <span class="material-icons align-middle">chevron_left</span> Back
      </button>

      <PauseDurationChips v-model="months" />

      <div v-if="error" class="alert alert-danger mt-3">{{ error }}</div>

      <button type="button" class="btn btn-primary w-100 mt-4" :disabled="submitting" @click="pause">
        <span v-if="submitting" class="spinner-border spinner-border-sm me-2"></span>
        Pause my subscription
      </button>
    </template>

    <FlowConfirmation
      v-else
      title="See you soon!"
      body-prefix="You have paused your subscription until "
      :bold="resumesOn"
      body-suffix="."
      @continue="$emit('done')"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import graphClient from "@/utils/graphql/graph_client";
import { PauseWebSubscription } from "@/utils/graphql/subscriptions";
import { errorMessage } from "../errorMessage";
import { pauseDurationEnum, longOrdinalDate, resumeDate } from "../subscriptionLogic";
import FlowConfirmation from "./FlowConfirmation.vue";
import PauseDurationChips from "./PauseDurationChips.vue";

defineEmits<{ (e: "close"): void; (e: "done"): void }>();

const months = ref(1);
const submitting = ref(false);
const error = ref("");
const confirmed = ref(false);
const resumesOn = ref("");

async function pause() {
  if (submitting.value) return;
  submitting.value = true;
  error.value = "";
  try {
    const res: any = await graphClient.request(PauseWebSubscription, {
      input: { durationMonths: pauseDurationEnum(months.value) },
    });
    const resumesAt = res?.pauseWebSubscription?.resumesAt;
    resumesOn.value =
      longOrdinalDate(resumesAt) || longOrdinalDate(resumeDate(new Date(), months.value)) || "";
    confirmed.value = true;
  } catch (e) {
    error.value = errorMessage(e);
  } finally {
    submitting.value = false;
  }
}
</script>
